export const FETCH_FEED_STARTED = 'feed/FETCH_FEED_STARTED';
export const FETCH_FEED_SUCCESS = 'feed/FETCH_FEED_SUCCESS';
export const FETCH_FEED_FAILURE = 'feed/FETCH_FEED_FAILURE';
